export default __webpack_public_path__ + "static/media/fold-btn.e6a59cd6.svg";